<template>
    <v-col cols="12" lg="8">
        <v-row justify="center">
            <v-card 
                elevation="0"
                class="bg-card mt-4 mb-12 my-lg-0"
                width="97%"
                :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?600:(this.$vuetify.breakpoint.xl?300:350)"
            >
                <v-row class="pl-lg-4 pl-xl-0">
                    <v-col class="bg-image" cols="12" md="5" xl="4" justify="center" align="center">
                        <v-img
                            :src="
                                `${$utils.globalConstants.BASE_ASSETS_URL}/lbr/image/${book.book.resourceDir}/cover_small.jpg`
                            "
                            class="mt-6 book-img border-radius-2"
                            max-height="230" max-width="170"
                            v-if="book&&!loading"
                        ></v-img>
                        <v-skeleton-loader
                            class="mt-2 opacity-none"
                            height="240"
                            width="180"
                            type="image"
                            :transition="'scale-transition'"
                            v-if="loading"
                        ></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" md="7" xl="8" align-self="center" class="pl-md-6 py-0" v-if="book&&!loading">
                        <v-row justify="center" justify-md="start">
                            <span class="mb-2 text-h4 text-left color-text">
                                {{ $t('home.super_recommended') }}
                            </span>
                        </v-row>
                        <v-row justify="center" justify-md="start">
                            <v-img
                                src="/img/user/star-filled.svg"
                                max-height="30"
                                max-width="30"
                                v-for="n in book.rating"
                                :key="n + '-filled'"
                            ></v-img>
                            <v-img
                                src="/img/user/star.svg"
                                max-height="30"
                                max-width="30"
                                v-for="n in (5-book.rating)"
                                :key="n"
                            ></v-img>
                        </v-row>
                        <v-row>
                            <p class="my-4 mx-4 mx-md-0 mr-md-6 mr-xl-12 pr-xl-12 text-subtitle-1 text-left font-weight-bold color-desc">
                                {{ book.description }}
                            </p>
                        </v-row>
                        <v-row justify="center" justify-md="start">
                            <v-btn
                                class="no-uppercase"
                                color="#FF6F3A"
                                dark
                                x-large
                                rounded
                                @click="assignRecommendedBook" :loading="btnLoading"
                            >
                                {{ $t('home.start_reading') }}
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="7" xl="8" align-self="center" class="pa-0 ma-0" v-if="loading">
                        <v-row class="pa-0 ma-0">
                            <v-col cols="12" class="pa-0 mt-md-8">
                                <v-row justify="center" justify-md="start" class="ma-0">
                                    <v-skeleton-loader
                                        class="opacity-none"
                                        height="35"
                                        width="65%"
                                        type="heading"
                                        :transition="'scale-transition'"
                                    ></v-skeleton-loader>
                                    <v-skeleton-loader
                                        class="opacity-none mt-3 mb-5"
                                        height="35"
                                        width="40%"
                                        type="heading"
                                        :transition="'scale-transition'"
                                    ></v-skeleton-loader>
                                </v-row>
                                <v-skeleton-loader
                                    class="opacity-none mt-8 mb-4"
                                    height="80"
                                    width="90%"
                                    type="paragraph"
                                    :transition="'scale-transition'"
                                ></v-skeleton-loader>
                                <v-row justify="center" justify-md="start" class="ma-0">
                                    <v-skeleton-loader
                                        class="opacity-none"
                                        height="60"
                                        width="220"
                                        type="button"
                                        :transition="'scale-transition'"
                                    ></v-skeleton-loader>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-overlay absolute :value="!book" opacity="0.6" class="mr-lg-6 mr-xl-0">
                        <v-row class="ma-0 pa-12 text-h6 text-md-h4 font-weight-regular" justify="center" align="center">
                            {{ $t('home.no_super_recommended')}}
                        </v-row>
                    </v-overlay>
                </v-row>
            </v-card>
        </v-row>
    </v-col>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import RecommendedService from '../../services/recommended'
import global from '@/constants/GlobalConstant'

export default {
    data() {
        return {
            book: true,
            btnLoading: false,
            loading: true
        }
    },
    created () {
        this.getRecommendedBook()
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
    },
    methods: {
        ...mapActions('bookReading', ['setRecommended']),
        assignRecommendedBook () {
            this.btnLoading = true
            RecommendedService.saveRecommendedBookUser(
                this.book.book.id,
                this.user.id
            )
            .then(() => {
                this.btnLoading = false
                this.setRecommended(true)
                this.$router.push(`/user/book/${this.book.book.id}`)
            })
            .catch((error) => console.error(error))
        },
        getRecommendedBook () {
            RecommendedService.getActiveForUser(
                this.user.id
            )
            .then((response) => {
                this.setRecommendedBook(response.content)
            })
            .catch((error) => console.error(error))
        },
        setRecommendedBook (data) {
            this.book = data
            this.loading = false
        }
    }
}
</script>

<style scoped>
.color-text {
    color: #4A3216;
}
.color-desc {
    color: #6C4416;
}
.bg-card {
    border-radius: 40px;
}
.bg-image {
    background-image: url("/img/user/super-recommended-bg.svg");
    background-repeat: no-repeat;
    background-position: 50% 0%;
    height: 300px;
}

@media (min-width: 960px) {
    .bg-image {
        background-position: 50% 0%;
        height: 350px;
    }
}

@media (min-width: 1904px) {
    .bg-image {
        background-position: 50% 0%;
        height: 300px;
    }
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__button {
    width: 100%;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__heading {
    height: 100%;
    width: 100%;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__image {
    height: 100%;
    width: 100%;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__paragraph {
    height: 100%;
    width: 100%;
}

.book-img {
  box-shadow: 0 0 18px -1px hsl(0, 0%, 44%);
}

</style>